// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mq43","col":"styles_col__3EASb"};